const authTexts = {
	ES: {
		logout: 'Cerrar session',
        hello: 'Hola, ',
        fastMoney: 'Bienvenido a tu cuenta. ¡Obtener efectivo ahora es aún más rápido!',
        protect: 'Es necesario para protegerlo del uso fraudulento de sus datos personales.',
        getMoney: 'Recibe dinero'
	},
	EN: {
        logout: 'Log out',
        hello: 'Hi, ',
        fastMoney: 'Welcome to your account. Now you can get your money even faster!',
        protect: 'It\'s required to protect you from fraudulent use of your personal data.',
        getMoney: 'Get your money'
	},
	UA: {
		logout: 'Вийти',
        hello: 'Привіт, ',
        fastMoney: 'Ласкаво просимо в особистий аккаунт. Тепер отримати гроші стало ще простіше!',
        protect: 'Необхідно для захисту ваших персональних даних від шахрайства.',
        getMoney: 'Отримати гроші'
	},
	RU: {
		logout: 'Выйти',
        hello: 'Привет, ',
        fastMoney: 'Добро пожаловать в личный аккаунт. Теперь получить деньги стало еще проще!',
        protect: 'Необходимо для защиты ваших персональных данных от мошенничества.',
        getMoney: 'Получить деньги'
	},
	VN: {
		logout: 'Thoát',
        hello: 'Xin chào,',
        fastMoney: 'Chào mừng bạn đến với tài khoản cá nhân của bạn. Bây giờ, nó thậm chí còn dễ dàng hơn để kiếm tiền! ',
        protect: 'Cần phải bảo vệ dữ liệu cá nhân của bạn khỏi gian lận.',
        getMoney: 'Nhận tiền'
	},
	1: function() { return this.ES },
	2: function() { return this.ES },
	3: function() { return this.EN },
	4: function() { return this.ES },
	5: function() { return this.ES },
	6: function() { return this.ES },
	7: function() { return (localStorage.getItem('lang') === 'ru') ? this.RU : this.UA },
	8: function() { return this.RU },
	9: function() { return this.VN },
}

export { authTexts }